<template>
  <ul class="buttons-container" :class="{ disabled }">
    <li v-for="i in 3" :key="i">
      <button @click="buttonClick(i)" :class="{ active: i === activeButton && disabled }" />
    </li>
  </ul>
</template>

<script>

import clickSFX from '../assets/sounds/click.mp3'
import errorSFX from '../assets/sounds/disabled.mp3'

import { Howl } from 'howler'

export default {
  name: 'buttons',
  props: {
    disabled: Boolean
  },
  data () {
    return {
      activeButton: null,

      clickSFX: new Howl({
        src: clickSFX
      }),
      errorSFX: new Howl({
        src: errorSFX
      })
    }
  },
  methods: {
    buttonClick (buttonId) {
      if (this.disabled) {
        this.errorSFX.play()
      } else {
        this.activeButton = buttonId
        this.clickSFX.play()
        this.$emit('click', buttonId)
      }
    }
  }
}
</script>

<style scoped lang="scss">
$button-background: #C90000 !default;
$button-background-active: #770000 !default;

.buttons-container {
  padding: 5vh 0 0;
  li {
    display: block;

    + li {
      margin-top: 50px;
    }
  }

  button {
    border: 0;
    cursor: pointer;
    text-align: center;
    text-decoration: none;
    color: #fff;
    width: 200px;
    height: 100px;
    background: $button-background;
    position: relative;
    margin: 30px;
    top: 100px;
    padding: 16px;
    font-size: 50px;
    border-radius: 10px;
    box-shadow: 0px 15px 0px 0px darken($button-background, 5%), 0px 0px 20px 0px #fff;
    transition: all 0.2s;
    -webkit-tap-highlight-color: transparent;

    &:active {
      top: 108px;
      box-shadow: 0px 7px 0px 0px $button-background;
    }

    &.active {
      background: $button-background-active;
      box-shadow: 0px 15px 0px 0px darken($button-background-active, 5%), 0px 0px 20px 0px #fff;

      &:active {
      box-shadow: 0px 7px 0px 0px $button-background-active;
      }
    }

    &:focus {
      outline: 0;
    }
  }
}
</style>
